var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { styled } from 'styled-components';
import { addMonths, isSameDay } from 'date-fns';
import { DatePicker } from '@hn-ui/datepickers';
import { LinkButton, TextButton } from '@hn-ui/buttons';
import { Calendar } from '@hn-ui/icons';
import { formatDates } from '../../../../utils/formatDates';
import { CancelButton } from '../../../../components/CancelButton';
var ScWrapper = styled.div.withConfig({ displayName: "ScWrapper", componentId: "sc-1t34b8l" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  line-height: 24px;\n  gap: 0 16px;\n\n  button {\n    width: auto;\n    padding: 0;\n  }\n\n  input {\n    font-family: inherit;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  line-height: 24px;\n  gap: 0 16px;\n\n  button {\n    width: auto;\n    padding: 0;\n  }\n\n  input {\n    font-family: inherit;\n  }\n"])));
var DateField = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, onSubmit = _a.onSubmit, onEdit = _a.onEdit, freezeStartDate = _a.freezeStartDate, editable = _a.editable;
    var _b = useState(false), dateEdit = _b[0], setDateEdit = _b[1];
    var _c = useState([
        startDate,
        endDate,
    ]), updatedValue = _c[0], setUpdatedValue = _c[1];
    var onDateSave = useCallback(function () {
        if (updatedValue) {
            onSubmit(updatedValue);
            setDateEdit(false);
        }
    }, [onSubmit, updatedValue]);
    var isSameDates = useMemo(function () {
        if (Array.isArray(updatedValue)) {
            return (isSameDay(updatedValue[0], startDate) &&
                isSameDay(updatedValue[1], endDate));
        }
        return isSameDay(updatedValue, endDate);
    }, [endDate, startDate, updatedValue]);
    var minDate = freezeStartDate ? startDate : new Date();
    var hasValidValue = useMemo(function () {
        if (Array.isArray(updatedValue)) {
            return !updatedValue.includes(null);
        }
        return Boolean(updatedValue);
    }, [updatedValue]);
    return (_jsxs(ScWrapper, { children: [dateEdit && (_jsxs(_Fragment, { children: [_jsx(DatePicker, { type: 'range', startDate: startDate, endDate: endDate, minDate: minDate, maxDate: addMonths(minDate, 1), onChange: function (value) {
                            setUpdatedValue(value);
                        }, freezeStartDate: freezeStartDate, popperPlacement: 'bottom-start' }, void 0), _jsx(TextButton, __assign({ disabled: !hasValidValue || isSameDates, onClick: onDateSave }, { children: "Save" }), void 0), _jsx(CancelButton, __assign({ onClick: function () {
                            setDateEdit(false);
                            setUpdatedValue(null);
                        } }, { children: "Cancel" }), void 0)] }, void 0)), !dateEdit && editable && (_jsxs(LinkButton, __assign({ "data-testid": 'assignment-details-edit-date', onClick: function () {
                    onEdit === null || onEdit === void 0 ? void 0 : onEdit();
                    setDateEdit(true);
                } }, { children: [_jsx("span", { children: formatDates(startDate, endDate) }, void 0), _jsx(Calendar, { size: 16 }, void 0)] }), void 0)), !editable && _jsx("span", { children: formatDates(startDate, endDate) }, void 0)] }, void 0));
};
export { DateField };
var templateObject_1;
